import * as React from 'react';


// ################################ // START HR MODULES (AUTHENTICATION) // ################################ //
// HalamanUser
const LoginPage = React.lazy(() => import('./Modules/HR_Module/User/loginpage'));
const PulihkanPasswordPage = React.lazy(() => import('./Modules/HR_Module/User/pulihkanpasswordpage'));
const ResetPasswordPage = React.lazy(() => import('./Modules/HR_Module/User/resetpasswordpage'));
const WelcomeTirta = React.lazy(() => import('./Modules/HR_Module/User/welcomeTirta'));

const GeneratePenawaran = React.lazy(() => import('./Modules/Inventory_Module/Quotation/generate'));
const StatusClient = React.lazy(() => import('./Modules/Medsite_Module/medivac/cek_status'));
const BuktiBayarClient = React.lazy(() => import('./Modules/Medsite_Module/medivac/bukti_bayar'));
const ApprovalClient = React.lazy(() => import('./Modules/Medsite_Module/medivac/approval_client'));

// ################################ // END HR MODULES (AUTHENTICATION) // ################################ //

const SignUp1 = React.lazy(() => import('./Demo/Authentication/SignUp/SignUp1'));
const SignUp2 = React.lazy(() => import('./Demo/Authentication/SignUp/SignUp2'));
const Signin1 = React.lazy(() => import('./Demo/Authentication/SignIn/SignIn1'));
const Signin2 = React.lazy(() => import('./Demo/Authentication/SignIn/SignIn2'));
const ResetPassword1 = React.lazy(() => import('./Demo/Authentication/ResetPassword/ResetPassword1'));
const ResetPassword2 = React.lazy(() => import('./Demo/Authentication/ResetPassword/ResetPassword2'));
const ChangePassword = React.lazy(() => import('./Demo/Authentication/ChangePassword'));
const ProfileSettings = React.lazy(() => import('./Demo/Authentication/ProfileSettings'));
const TabsAuth = React.lazy(() => import('./Demo/Authentication/TabsAuth'));
const Error = React.lazy(() => import('./Demo/Maintenance/Error'));
const OfflineUI = React.lazy(() => import('./Demo/Maintenance/OfflineUI'));
const ComingSoon = React.lazy(() => import('./Demo/Maintenance/ComingSoon'));
const route = [
    { path: '/auth/signup-1', exact: true, name: 'Signup 1', component: SignUp1 },
    { path: '/auth/signup-2', exact: true, name: 'Signup 2', component: SignUp2 },
    { path: '/auth/signin-1', exact: true, name: 'Signin 1', component: Signin1 },
    { path: '/auth/signin-2', exact: true, name: 'Signin 2', component: Signin2 },
    { path: '/auth/reset-password-1', exact: true, name: 'Reset Password 1', component: ResetPassword1 },
    { path: '/auth/reset-password-2', exact: true, name: 'Reset Password 2', component: ResetPassword2 },
    { path: '/auth/change-password', exact: true, name: 'Change Password', component: ChangePassword },
    { path: '/auth/profile-settings', exact: true, name: 'Profile Settings', component: ProfileSettings },
    { path: '/auth/tabs-auth', exact: true, name: 'Tabs Authentication', component: TabsAuth },
    { path: '/maintenance/error', exact: true, name: 'Error', component: Error },
    { path: '/maintenance/coming-soon', exact: true, name: 'Coming Soon', component: ComingSoon },
    { path: '/maintenance/offline-ui', exact: true, name: 'Offline UI', component: OfflineUI },

    // ################################ // START HR ROUTES (AUTHENTICATION) // ################################ //
    { path: '/auth/login-page', exact: true, name: 'Login Page', component: LoginPage},
    { path: '/auth/pulihkan-password-page', exact: true, name: 'Pulihkan Password Page', component: PulihkanPasswordPage},
    { path: '/auth/reset-password-page/:token', exact: true, name: 'Reset Password Page', component: ResetPasswordPage},
    { path: '/welcome-tirta', exact: true, name: 'Welcome Tirta', component: WelcomeTirta },

    { path: '/penawaran/:id', exact: true, name: 'Penawaran', component: GeneratePenawaran },
    { path: '/cek_status/:id', exact: true, name: 'Status Client', component: StatusClient },
    { path: '/bukti_bayar/:id', exact: true, name: 'Bukti Bayar', component: BuktiBayarClient },
    { path: '/approval_client/:id', exact: true, name: 'Approval Client', component: ApprovalClient },
    
    

    // ################################ // END HR ROUTES (AUTHENTICATION) // ################################ //
];
export default route;
